"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/styles");
var _excluded = ["children", "className", "disabled", "onKeyPress"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type Node } from 'react';*/
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      minWidth: '10rem',
      display: 'block',
      padding: '.5rem 1rem',
      paddingTop: theme.functions.toRem(theme.variables.menuItemPaddingTop),
      paddingRight: theme.functions.toRem(theme.variables.menuItemPaddingRight),
      paddingBottom: theme.functions.toRem(theme.variables.menuItemPaddingBottom),
      paddingLeft: theme.functions.toRem(theme.variables.menuItemPaddingLeft),
      width: '100%',
      color: theme.colors.black,
      listStyle: 'none',
      textAlign: 'left',
      cursor: 'pointer',
      verticalAlign: 'bottom',
      '&:first-child': {
        borderTopLeftRadius: theme.variables.borderRadiusSmall,
        borderTopRightRadius: theme.variables.borderRadiusSmall
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.variables.borderRadiusSmall,
        borderBottomRightRadius: theme.variables.borderRadiusSmall
      },
      '&:hover': {
        backgroundColor: theme.colors.blueGrey,
        '& *': {
          backgroundColor: 'inherit'
        }
      },
      '&[disabled], &[disabled] *': theme.mixins.disabled
    })
  };
});
/*:: export type MenuItemProps = {
  className?: string,
  disabled?: boolean,
  onClick?: (...args: Array<any>) => any,
  onKeyPress?: (...args: Array<any>) => any
};*/
/*:: type Props = MenuItemProps & {
  children: Node
};*/
var MenuItem = function MenuItem(_ref /*:: */) /*: Node*/{
  var children = _ref /*:: */.children,
    className = _ref /*:: */.className,
    disabledProp = _ref /*:: */.disabled,
    onKeyPress = _ref /*:: */.onKeyPress,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  var classes = useStyles();
  return _react.default.Children.map(children, function (child) {
    var _child$props;
    // string-typed children do not have props, therefore use optional chaining
    var disabled = disabledProp || (child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.disabled);
    return _react.default.isValidElement(child) ? _react.default.cloneElement(child, _objectSpread({
      className: (0, _classnames.default)(classes.root, className),
      disabled: disabled,
      onKeyPress: !disabled ? onKeyPress : undefined
    }, props)) : child;
  });
};
MenuItem.defaultProps = {
  disabled: false
};
var _default = exports.default = MenuItem;
//# sourceMappingURL=MenuItem.js.map